import { VERTICALS } from '../data/verticals';
import VerticalPage from './VerticalPage';

const Schools = () => <VerticalPage config={VERTICALS['schools']} />;

export default Schools;
